<template>
	<div class="home-nav">
		<ul class="home-nav__items">
			<RouterLink :class="{'home-nav__item--active': key == activeNav, 'home-nav__item--icon': item.icon}" :to="item.link" v-for="(item, key) in navItems" :key="key" custom v-slot="{href, navigate, isActive, isExactActive}" >
				<li class="home-nav__item" :href="href" @click="navigate()" :class="{'home-nav__item--exact-active': isExactActive, 'home-nav__item--active': isActive,}">
					<span class="home-nav__item-icon" v-if="item.icon"><IconCircle :icon="item.icon" :style="`--background: var(${item.background})`" /></span>
					<span class="home-nav__item-label" v-html="item.label"></span>
				</li>
			</RouterLink>
		</ul>
	</div>
</template>

<script>
import IconCircle from '@/components/IconCircle.vue'

export default {
	name: 'HomeNav',
	components: {
		IconCircle,
	},
	data: () => ({
		navItems: [
			{
				label: `All`,
				link: {name: 'home', params: { filter: ''}},
			},
			{
				label: `Leadership`,
				link: {name: 'home', params: { filter: 'leadership'}},
				icon: 'person',
				background: '--color--leadership'
			},
			{
				label: `Delivering Value`,
				link: {name: 'home', params: { filter: 'value'}},
				icon: `diamond`,
				background: '--color--value',
			},
			{
				label: `Insights Into Action`,
				link: {name: 'home', params: { filter: 'insights'}},
				icon: `star`,
				background: '--color--insights',
			},
			{
				label: `Responsibility`,
				link: {name: 'home', params: { filter: 'responsibility'}},
				icon: `heart`,
				background: '--color--responsibility',
			},
		],
		activeNav: 0,
	})
}
</script>

<style scoped lang="scss">
.home-nav {
	--height: 4rem;
	--items-width: var(--max-width);

	@include modules.media-query('phone') {
		--height: 2.8rem;
		--items-width: 960px;
	}

	font-family: var(--font-family--label);
	margin: 2rem auto;
	overflow-x: scroll;
	position: sticky;
	top: 2rem;
	scrollbar-width: none;
	z-index: 9;
	width: 100%;

	// background:
	// 	linear-gradient(to right, rgba(0, 0, 0, 0.2), transparent 30px) left,
	// 	linear-gradient(to left, rgba(0, 0, 0, 0.2), transparent 30px) right;
	// background-size: 30px 100%;
	// background-repeat: no-repeat;
	// background-attachment: local;

	// background:
	// 		/* Shadow Cover TOP */
	// 		linear-gradient(
	// 			to right,
	// 		white 30%,
	// 		rgba(255, 255, 255, 0)
	// 		) center top,

	// 		/* Shadow Cover BOTTOM */
	// 		linear-gradient(
	// 			to left,
	// 		rgba(255, 255, 255, 0),
	// 		white 70%
	// 		) center bottom,

	// 		/* Shadow TOP */
	// 		radial-gradient(
	// 		farthest-side at 50% 0,
	// 		rgba(0, 0, 0, 0.2),
	// 		rgba(0, 0, 0, 0)
	// 		) center center,

	// 		/* Shadow BOTTOM */
	// 		radial-gradient(
	// 		farthest-side at 50% 100%,
	// 		rgba(0, 0, 0, 0.2),
	// 		rgba(0, 0, 0, 0)
	// 		) center center;

		// background-repeat: no-repeat;
		// background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
		// // background-size: 100% 40px, 100% 40px, 100% 14px, 100% 14px;
		// background-attachment: local, local, scroll, scroll;

	// &::-webkit-scrollbar {
	// 	display: none;
	// }

	&__items {
		display: grid;
		grid-auto-flow: column;
		// grid-template-columns: repeat(auto-fit, minmax(150px, max-content));
		grid-template-columns: max-content;
		column-gap: 10px;
		list-style-type: none;
		margin: 0;
		padding: 0;
		position: relative;
		min-width: calc(var(--items-width) - 28rem);

		@include modules.media-query('phone') {
			grid-auto-flow: column;
			grid-template-columns: minmax(60px, max-content);
			width: calc(var(--items-width) - 7.5rem);
		}
	}

	&__item {
		$item: &;
		align-items: center;
		background-color: var(--color--hunter-green);
		border-radius: 4rem;
		cursor: pointer;
		display: grid;
		font-size: 1.25rem;
		font-weight: 300;
		letter-spacing: 0.025rem;
		line-height: var(--height);
		transition: background-color 150ms ease-out, color 150ms ease-out;
		will-change: color, background-color;

		&--icon {
			grid-template-columns: auto 1fr;
		}

		&--exact-active {
			background-color: var(--color--cream);
			color: var(--color--hunter-green);
		}

		@include modules.media-query('phone') {
			font-size: 0.875rem;
			display: flex;
			flex-direction: row;
		}

		&-icon {
			--size: 54px;
			@include modules.media-query('tablet') {
				--size: 38px;
			}
			@include modules.media-query('phone') {
				--size: 38px;
			}
			margin-left: 6px;
		}

		&-label {
			flex: 1;
			text-align: center;
			text-transform: uppercase;
			margin-right: 2rem;
			margin-left: 2rem;
			letter-spacing: 0.025rem;
			padding: 0 0.25rem;

			@include modules.media-query('phone') {
				margin-left: 0.5rem;
				margin-right: 0.5rem;
			}

			#{$item}--icon & {
				margin-left: 0;
				margin-right: 0;
			}
		}
	}
}
</style>
